import { useApi } from '@src/app/context/Api';
import fields from '@src/entities/ActionPath/includes/fields.json';
import { abbrNum } from '@src/shared/includes/functions';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import { isEmpty, isNull, isUndefined } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';

import { Table } from './components/Table';
import { Styles } from './includes/styles';

const { exitCriteriaMethod: exitCriteriaMethodField } = fields;

/**
 * Widget: FilterCriteria
 *
 * @TODO Needs description
 *
 * @param context
 * @param criteria
 * @param criteriaMethod
 * @param filterKey
 * @param setCountCallback
 * @returns {Element}
 * @constructor
 */
export function FilterCriteria({
  context = '',
  criteria = {
    entrance: {
      additional: [],
      common: [],
      merged: [],
    },
    exit: {
      additional: [],
      common: [],
      merged: [],
    },
  },
  criteriaMethod = '',
  filterKey = 'filters',
  setCountCallback = () => {},
}) {
  const [count, setCount] = useState(null);

  const { useApiQuery } = useApi('RiskRecord');
  const [GetRiskRecordsCount, { data: riskRecordsCount }] = useApiQuery('GetRiskRecordsCount');

  /**
   * Get the total number of risk records if not already fetched.
   */
  useEffect(() => {
    if (isUndefined(riskRecordsCount) && !isEmpty(criteria?.[context]?.merged)) {
      if (context === 'entrance') {
        GetRiskRecordsCount({
          criteria: {
            entrance: criteria?.entrance,
          },
        });
      }

      if (context === 'exit') {
        GetRiskRecordsCount({ criteria });
      }
    }
  }, [riskRecordsCount, criteria]);

  /**
   * Set the count of risk records.
   */
  useEffect(() => {
    if (!isUndefined(riskRecordsCount)) {
      if (context === 'entrance') {
        setCount(riskRecordsCount?.entranceCriteriaCount);
        setCountCallback(riskRecordsCount?.entranceCriteriaCount);
      }

      if (context === 'exit') {
        setCount(riskRecordsCount?.exitCriteriaCount);
        setCountCallback(riskRecordsCount?.exitCriteriaCount);
      }
    }
  }, [riskRecordsCount]);

  /**
   * add the type of criteria to the rows
   * @type {*[]}
   */
  const rows = useMemo(() => {
    const theRows = [];

    // add additional criteria
    if (!isEmpty(criteria?.[context]?.additional)) {
      criteria?.[context]?.additional.forEach((row) => {
        const theRow = {
          ...row,
          ...{
            type: 'additional',
          },
        };
        if (!theRows.includes(theRow)) {
          theRows.push(theRow);
        }
      });
    }

    // add common criteria
    if (!isEmpty(criteria?.[context]?.common)) {
      criteria?.[context]?.common.forEach((row) => {
        const theRow = {
          ...row,
          ...{
            type: 'common',
          },
        };
        if (!theRows.includes(theRow)) {
          theRows.push(theRow);
        }
      });
    }

    return theRows;
  }, [criteria]);

  let title = '';

  if (context === 'entrance') {
    title = 'Entrance Criteria';
  }

  if (context === 'exit') {
    title = 'Exit Criteria';
  }

  const theCriteriaMethod = useMemo(() => {
    return exitCriteriaMethodField?.options?.find((option) => {
      return option?.value === criteriaMethod;
    });
  }, [criteriaMethod, criteria]);

  return (
    <ErrorHandler location="src/widgets/Criteria/FilterCriteria/FilterCriteria.jsx">
      <Styles>
        <Widget
          button={
            !isUndefined(riskRecordsCount) &&
            !isNull(count) && (
              <Badge outline variant="info">
                {abbrNum(count)} records
              </Badge>
            )
          }
          description=""
          title={title}
        >
          {isEmpty(criteriaMethod) || criteriaMethod === 'EXIT_CRITERIA_MET' ? (
            <Table filterKey={filterKey} rows={rows || []} />
          ) : (
            theCriteriaMethod?.label
          )}
        </Widget>
      </Styles>
    </ErrorHandler>
  );
}
